export const ru = {
    allSpecialists: 'Все специалисты',
    becomeSpecialist: 'Стать специалистом',
    customer: 'Заказчик',
    myCustomers: 'Мои заказчики',
    myOwnCampaigns: 'Мои кампании',
    myProfile: 'Мой профиль',
    mySpecialist: 'Мой специалист',
    specialistsOfYandexDirect: 'специалисты по настройке Яндекс.Директа'
};
